import React, { useContext, useEffect, useState } from 'react';
import { KFLDropmenugroup, KFLDropmenuitem } from '@kamstrup/kamstrup-frontend-library';
import { LocaleCtx } from '../../contexts/locale.context';
import { AppKeys } from '../../core/localization/const';
import { ReduxState } from '../../interfaces';
import { English, Spanish, Danish, American } from '../../core/localization';
import { useSelector } from 'react-redux';
import useApp from '../../hooks/useApp';
import { setModal, setRightPanel } from '../../modules/dialogs/actions';
import { Modals, Panels } from '../../modules/dialogs/model';
import { useSecurity } from '../../libs/security/useSecurity';
import { getToken, printToken as printTk } from '../../core/security/utils';
import Ellipsis from '../shared/ellipsis';

type Props = {
  isLoggedIn?: boolean;
  isDevelopment?: boolean;
};
export const UserLinks: React.FC<Props> = ({ isLoggedIn, isDevelopment }) => {
  const { translate } = useContext(LocaleCtx);
  const { setLanguage } = useApp();
  const { lang } = useSelector((s: ReduxState) => s.localizationState);
  const security = useSecurity();

  const isCurrentLang = (langCode: string) => langCode === lang;
  const [token, setToken] = useState('');
  useEffect(()=>{
    getToken().then((t)=>{ setToken(t ?? '');})
  },[])

  const signIn = (
    <KFLDropmenuitem
      key={AppKeys.topheader_signin}
      text={translate(AppKeys.topheader_signin)}
      onClick={security.signIn}
    />
  );
  const signOut = (
    <KFLDropmenuitem
      key={AppKeys.topheader_signout}
      text={translate(AppKeys.topheader_signout)}
      onClick={security.signOut}
    />
  );
  const printToken = (
    <>
      <KFLDropmenuitem
        data-token={token}
        key="dev-print-token"
        text="Print Token"
        onClick={printTk}
      />
      <div
        className="Dropmenuitem__secondarytext"
        style={{
          width: '100px',
          display: 'block',
          padding: '0 15px',
          marginTop: '-20px',
        }}
      >
        <Ellipsis>{token}</Ellipsis>
      </div>
    </>
  );

  const englishKey = `dev-translate-${English.name}`;
  const EnglishLang = isCurrentLang(English.folder) ? (
    <React.Fragment key={englishKey} />
  ) : (
    <KFLDropmenuitem
      key={englishKey}
      text={English.name}
      onClick={() => setLanguage(English.folder)}
    />
  );

  const spanishKey = `dev-translate-${Spanish.name}`;
  const SpanishLang = isCurrentLang(Spanish.folder) ? (
    <React.Fragment key={spanishKey} />
  ) : (
    <KFLDropmenuitem
      key={spanishKey}
      text={Spanish.name}
      onClick={() => setLanguage(Spanish.folder)}
    />
  );

  const danishKey = `dev-translate-${Danish.name}`;
  const DanishLang = isCurrentLang(Danish.folder) ? (
    <React.Fragment key={danishKey} />
  ) : (
    <KFLDropmenuitem
      key={danishKey}
      text={Danish.name}
      onClick={() => setLanguage(Danish.folder)}
    />
  );

  const americanKey = `dev-translate-${American.name}`;
  const AmericanLang = isCurrentLang(American.folder) ? (
    <React.Fragment key={americanKey} />
  ) : (
    <KFLDropmenuitem
      key={americanKey}
      text={American.name}
      onClick={() => setLanguage(American.folder)}
    />
  );

  const testModalKey = `dev-dialog-modal`;
  const TestModal = (
    <KFLDropmenuitem
      key={testModalKey}
      text={'Test Modal'}
      onClick={() => setModal(Modals.HELLO_WORLD)}
    />
  );
  const testRightPanelKey = `dev-dialog-rightpanel`;
  const TestRightPanel = (
    <KFLDropmenuitem
      key={testRightPanelKey}
      text={'Test Right Panel'}
      onClick={() => setRightPanel(Panels.HELLO_WORLD)}
    />
  );

  const items = [
    ...(isLoggedIn && isDevelopment ? [printToken] : []),
    ...(isLoggedIn ? [signOut] : [signIn]),
    ...(isLoggedIn && isDevelopment
      ? [EnglishLang, DanishLang, AmericanLang, SpanishLang]
      : []),
    ...(isLoggedIn && isDevelopment ? [TestModal, TestRightPanel] : []),
  ];

  return <KFLDropmenugroup>{items.map((p) => p)}</KFLDropmenugroup>;
};

export default UserLinks;
